import './PwaInstallBanner.scss';

import { faHeart } from '@fortawesome/pro-solid-svg-icons';
import { ChevronRight } from '@mui/icons-material';
import { KeyboardEvent } from 'react';

import Icon from '../../../components/Icon';
import Config from '../../../config';
import { getPwaInstallBannerText } from '../constants';

export interface IPwaInstallBannerProps {
    onInstallClick: () => void;
}

export function PwaInstallBanner({ onInstallClick }: IPwaInstallBannerProps) {
    const bannerText = getPwaInstallBannerText(Config.PWA_INSTALL_BONUS_COINS, Config.GLOBAL_SITE_COINS);

    const onKeyDown = (event: KeyboardEvent<HTMLDivElement>) => {
        if (event.key === 'Enter' || event.key === ' ') {
            event.preventDefault();
            onInstallClick();
        }
    };

    return (
        <div
            id="pwa-install-banner"
            className="pwa-install-banner"
            role="button"
            tabIndex={0}
            aria-label={`${bannerText}. Tippen zum Installieren`}
            onClick={onInstallClick}
            onKeyDown={onKeyDown}
        >
            <div className="pwa-install-banner__content">
                <Icon icon={faHeart} iconColor="#fff" fontSize="small" />
                <span className="pwa-install-banner__text">{bannerText}</span>
            </div>
            <ChevronRight className="pwa-install-banner__chevron" aria-hidden />
        </div>
    );
}

export default PwaInstallBanner;
